import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import { Send, Lightbulb } from "lucide-react";
import TextArea from "antd/es/input/TextArea";
import { Modal } from "antd";
import IndexModal from "components/modal";
import Card from "components/card";
import Button  from "components/button";
import HeaderComponent from "components/card/HeaderComponent";

import { 
    doAgentChat
} from "../../redux/copilot/copilotState";
import ChatMessageView from "./ChatMessageView";
import { ReactComponent as EliHead } from 'assets/svg/Eli_Chatbot.svg';

const ChatEli = ({doChatMessage, responseData, requesting, size, ...props}) => {
    const [showChatEli, setShowChatEli] = useState(false);
    const [showResponseBox, setShowResponseBox] = useState(false);
    const [chatMessage, setChatMessage] = useState('');
    const onClickGenerate = () => {
        if(chatMessage !== ''){
            doChatMessage({field: 'chat', message: chatMessage});
            setChatMessage('');
        }
    }

    useEffect(() => {
        if(responseData){
            setShowResponseBox(true);
        }
    }, [responseData]);

    const chatEndRef = useRef(null);

    useEffect(() => {
        chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
    }, [responseData]);

    return (
        <>
            <div className="fixed bottom-[20px] right-[10px] z-[9999]">
                <div className='flex items-center cursor-pointer p-2 rounded-full bg-primary-2' onClick={() => setShowChatEli(!showChatEli)}>
                    <EliHead 
                        style={{ 
                        color: "#fff",
                        width: 'auto', 
                        height: `${
                            size === "small"
                                ? "44px"
                                : size === "large" 
                                ? "84px"
                                : "64px"
                            }`
                        }}
                    />
                </div>
            </div>
            <Modal
                open={showChatEli}
                onClose={() => setShowChatEli(false)}
                width={400}
                footer={null}
                closable={false}
                destroyOnClose
                centered={false}
                style={{
                    position: 'fixed',
                    bottom: '90px',
                    right: '30px',
                    top: 'unset',
                    margin: 0,
                    padding: 0,
                }}
                styles={{
                    body: {
                    padding: 0,
                    },
                }}
                className="no-padding-ant-modal-content z-[999999]"
                >
                <div className={`overflow-y-auto rounded-md`}>
                    <HeaderComponent
                        title="Eli"
                        titleClass="text-white font-bold"
                        description="Your AI assistant"
                        descriptionClass="text-white"
                        bgcolor="!p-3 bg-gradient-to-br from-emerald-500 via-green-600 to-purple-600"
                        icon={<Lightbulb />}
                        colorTheme="text-white rounded-t-xl bg-white/20 backdrop-blur-sm flex items-center justify-center shadow-lg group-hover:scale-110 duration-300"
                        >
                            <div className="max-h-[360px] overflow-auto py-2 mt-3">
                                {responseData?.map((chat) => (
                                    <ChatMessageView chat={chat}/>
                                ))}
                                <div ref={chatEndRef} />
                            </div>
                            <div className="pt-4 flex gap-2">
                                <TextArea
                                    className="input-field"
                                    placeholder="Ask me anything..." 
                                    rows={1}
                                    value={chatMessage}
                                    onChange={(e) => setChatMessage(e.target.value)}
                                    onKeyDown={(e) => {
                                            if (e.key === "Enter" && !e.shiftKey) {
                                            e.preventDefault();
                                            onClickGenerate();
                                            }
                                        }}
                                />
                                <Button 
                                    className="flex items-center justify-center gap-2 border border-gray-300 rounded-2xl p-3 text-[16px] text-white font-medium bg-gradient-to-br from-emerald-500 to-purple-600 hover:bg-gray-50 transition"
                                    onClick={onClickGenerate}>
                                    <Send className="w-5 h-5" /> 
                                </Button>
                            </div>
                    </HeaderComponent>
                </div>
            </Modal>
        </>
    );
};

const mapStateToProps = (state) => ({
    responseData: state.copilot.chatData?.results,
    requesting: state.copilot.chatData?.requesting,
	success: state.copilot.chatData?.succcess,
  	error: state.copilot.chatData?.error,
});

const mapDispatchToProps = (dispatch) => ({
    doChatMessage: (data) => dispatch(doAgentChat(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ChatEli);
